import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneVerificationPopupComponent } from './phone-verification-popup.component';
import { SharedModule } from '../../shared/shared.module';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';




@NgModule({
  declarations: [
    PhoneVerificationPopupComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DialogModule,
    ButtonModule
  ],
  exports:[PhoneVerificationPopupComponent]
})
export class PhoneVerificationPopupModule { }
